//hb-nav-large-screens

Directives.NavLargeScreensDirective = function NavLargeScreensDirective() {

    // @ngInject
    function NavLargeScreensControllerFunc($scope, $injector, $state, AppStates, UsersManager, EventService, Enums,
                                           DeviceService, AnalyticsService, ReferralService, FeaturesService, UiPersistenceService,
                                           AbTestService, OnboardingService, NavigationService, ModalService, UserService, DoodleService, ClientPortalService) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'NavLargeScreensDirectiveController';

        this.AppStates = AppStates;
        this.EventService = EventService;
        this.Enums = Enums;
        this.DeviceService = DeviceService;
        this.AnalyticsService = AnalyticsService;
        this.ReferralService = ReferralService;
        this.$state = $state;
        this.FeaturesService = FeaturesService;
        this.UiPersistenceService = UiPersistenceService;
        this.NavigationService = NavigationService;
        this.OnboardingService = OnboardingService;
        this.AbTestService = AbTestService;
        this.ModalService = ModalService;
        this.UserService = UserService;
        this.DoodleService = DoodleService;
        this.ClientPortalService = ClientPortalService;

        // init
        this.showSnowbird = true;
        this.showActivityNotifications = false;
        this.showTools = false;
        this.showProfile = false;
        this.user = UsersManager.getCurrUser();
        this.clientPortalConfiguration = this.ClientPortalService.getConfiguration()

        this.MAX_SHOWN_NOTIFICATIONS_NUMBER = 100;

        UsersManager.on('update_notification_count', function updateNotificationCount() {
            if (!this.user.isClient()) {
                this.totalUnseenNotifications = this.user.getUnseenNotificationsCount();
            }
        }.bind(this));

        // Medium screen hides main menu
        this.searchInput = {
            inputFocus : false
        };

        // notifications
        this.totalUnseenNotifications = 0;
        this.totalUnseenNotificationsFormatted = 0;

        // vendor notifications
        if (!this.user.isClient()) {
            this.totalUnseenNotifications = this.user.getUnseenNotificationsCount();
        }

        this.isNavCommunity = NavigationService.isNavCurrentCommunity();
        this.isCompanyOwner = this.user.isCompanyOwner();

        this.showNewTools = this.UserService.showToolsByCategory(this.user);
        var toolsAbTestVariant = this.user.getExistingAbTestVariation(this.Enums.ABTests.toolsCatalogRedesign);

        $scope.$watch('navLargeVm.showTools', function(newValue) {
           if (newValue) {
               this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.tools_hover, {app_path : 'top_nav', variant: toolsAbTestVariant});
           }
        }.bind(this));

        // referral
        ////////////////////////////////////////////////////////
        // TODO : Remove from here
        // Need to use existing 'hb-refer-friend' directive,
        // but we need to rafactor it so it will fit here as
        // well. For now, extracted the logic from there
        ////////////////////////////////////////////////////////
        this.showReferrAFriend = false;
        if (this.user.companyHasSubscription() && !this.DeviceService.checkIfMobileSize()) {
            this.ReferralService.getCampaignDetails(this.user).then(function success(campaignDetails) {
                if (campaignDetails && campaignDetails.campaign_uid) {
                    this.showReferrAFriend = true;
                }
            }.bind(this));
        }
        ////////////////////////////////////////////////////////
        // END
        ////////////////////////////////////////////////////////

        // listen
        $scope.$watch('navLargeVm.showActivityNotifications', function(newVal) {
            this.onNotificationsShowChange(newVal);
        }.bind(this));

        $scope.$watch('navLargeVm.totalUnseenNotifications', function(newNotificationsCount, oldNotificationsCount) {
            this.totalUnseenNotificationsFormatted = (newNotificationsCount < this.MAX_SHOWN_NOTIFICATIONS_NUMBER) ? newNotificationsCount : '99+';
        }.bind(this));

        // TEMP: Send if user see opportunities outside of tools
        if(this.user.show_opportunities) {
            this.AnalyticsService.track(this, 'main opportunities link shown');
        }

    }

    var NavLargeScreensController = Class(Controllers.BaseController, {
        constructor: NavLargeScreensControllerFunc,

        referAFriendClick: function referAFriendClick() {
            this.AnalyticsService.trackClick(this, this.AnalyticsService.analytics_events.refer_a_friend, {
                icon: this.DoodleService.isDoodle(this.Enums.doodles.winter) ? 'snow globe' : 'coin'
            });
            this.ReferralService.openReferAFriend();
        },

        isDoodle: function isDoodle(name) {
            return this.DoodleService.isDoodle(name);
        },

        hideTools: function hideTools() {
            this.showTools = false;
        },

        toggleNotifications: function toggleNotifications(val) {
            if(val !== undefined) {
                this.showActivityNotifications = val;
            } else {
                this.showActivityNotifications = !this.showActivityNotifications;
            }

            this.toggleOnHoverNotificationsCallback();
        },

        shouldShowTrialText: function shouldShowTrialText() {
            return this.OnboardingService.showOnboardingBar() &&
                !this.isNavCommunity;
        },

        toggleOnHoverNotificationsCallback: function toggleOnHoverNotificationsCallback() {
            if(!this.showActivityNotifications) {
                this.scrollListToTop();
            }

            // hide avatar popup if notifications is shown
            if(this.showActivityNotifications) {
                this.showProfile = false;
            }
        },

        scrollListToTop: function scrollListToTop() {
            angular.element('.activities-list-container').scrollTop(0);
        },

        getDaysTillTrialEnds: function getDaysTillTrialEnds() {
            return this.user && this.user.nTillTrialEnds();
        },

        onUpgradeNow: function onUpgradeNow() {
            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.action, {
                unique: 'membership page',
                source: 'top_nav',
                trial_days_left: this.getDaysTillTrialEnds()
            });

            this.$state.go(this.AppStates.root_core_navigation_settings_companySettings_subscription);

        },

        onNotificationsShowChange: function onNotificationsShowChange(isShown) {
            if (!this.user.isClient()) {
                this.totalUnseenNotifications = this.user.getUnseenNotificationsCount();
            }
        },

        onAvatarDropdownSelect: function onAvatarDropdownSelect() {
            this.showProfile = false;
        },

        onHoverProfile: function onHoverProfile(val) {
            this.showActivityNotifications = false;
        },

        toggleLeftEventPanelOpen: function toggleLeftEventPanelOpen() {
            this.appState.leftPanelEventOpen = !this.appState.leftPanelEventOpen;
        }

    });

    return {
        templateUrl: 'angular/app/modules/core/features/top_nav/nav_large_screens/nav_large_screens_template.html',
        controller: NavLargeScreensController,
        controllerAs: 'navLargeVm',
        bindToController: true,
    };
};
